import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthGuardService } from './auth-guard-service';

export const authGuard = (activatedRoute: ActivatedRouteSnapshot) => {
    const authService = inject(AuthGuardService);

    return authService.canActivate(activatedRoute);
};
